import { pathJoin } from 'src/reducers/routing/utils'

export const createTicketsRoutesMap = (prefix: string) => ({
  'ticket-types': pathJoin(prefix)('ticket-types').chain,
  'ticket-category': pathJoin(prefix)('ticket-category').chain,
  'order-customisation': pathJoin(prefix)('order-customisation').chain,
  'ticket-message-templates': pathJoin(prefix)(
    'ticket-message-templates'
  ).chainMapAuto((prefix2) => ({
    ':id': (id = ':id') => pathJoin(prefix2)(id).chain,
  })),
})
